export const PricingHero = () => (
  <section className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-10 sm:pt-12 pb-10 sm:pb-16" aria-label="Pricing introduction">
    <h1 className="text-4xl sm:text-5xl font-bold tracking-tight leading-[1.1] text-primary mb-6 sm:mb-8">Pricing</h1>
    <div className="h-1 w-16 bg-primary mb-8 sm:mb-12" aria-hidden="true" />
    <div className="grid lg:grid-cols-[1fr_auto] gap-8 lg:gap-16 items-end">
      <div>
        <div className="flex items-end gap-3 sm:gap-4" aria-hidden="true">
          <img src="/lovable-uploads/odyvoy-icon.png" alt="" width={104} height={104} className="h-16 w-16 sm:h-24 sm:w-24 object-contain" />
          <div className="pb-1">
            <p className="text-3xl sm:text-5xl font-bold leading-none text-primary">OdyVoy</p>
            <p className="mt-2 text-sm sm:text-lg text-primary/80">Your Odyssey. Our Voyage!</p>
          </div>
        </div>
      </div>
      <div className="lg:max-w-md">
        <div className="flex items-center gap-4 mb-3">
          <span className="text-[11px] font-semibold uppercase tracking-[0.2em] text-primary whitespace-nowrap">Plan selection</span>
          <span className="h-px flex-1 bg-border" aria-hidden="true" />
        </div>
        <p className="text-base sm:text-lg leading-snug text-foreground">
          Everything to check before you go, in one place. Start free, add a Boost Pass for a single trip, or keep a subscription running.
        </p>
      </div>
    </div>
  </section>
);
